export default __webpack_public_path__ + "static/media/users-white.a11b5916.svg";